import React, { useEffect } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaTimes } from "react-icons/fa";
const Myswal = withReactContent(Swal);
const WarningModal = ({ isOpen, setIsOpen, onConfirm }) => {
  useEffect(() => {
    if (isOpen) {
      Myswal.fire({
        width: "395px",
        html: (
          <div>
            <div className="d-flex justify-content-end">
              <FaTimes
                color="#50a193"
                size={15}
                fontWeight={"bolder"}
                className="cursor-pointer"
                onClick={() => Myswal.close()}
              />
            </div>
            <h4 className="text_primary font-weight-bold fs-18 mb-35">
              Warning
            </h4>
            <p className="fs-15 mb-1">
              Are you sure you want to clear this screen?
            </p>
            <p className="fs-15 mb-43">
              <span className="font-weight-bold">Note:</span> All data will be
              lost
            </p>
            <div className="d-flex justify-content-between">
              <button
                className="btn btn_outline_danger overlay-btn small-text"
                onClick={() => Myswal.close()}
              >
                GO BACK
              </button>
              <button
                className="btn btn-outline-primary overlay-btn small-text"
                onClick={() => {
                  Myswal.close();
                  if (onConfirm) {
                    onConfirm();
                  } else {
                    window.location.reload();
                  }
                }}
              >
                YES
              </button>
            </div>
          </div> 
        ),
        focusConfirm: false,
        showConfirmButton: false,
        willClose: () => setIsOpen(false),
      });
    }
  }, [isOpen, setIsOpen, onConfirm]);
  return null;
};

export default WarningModal;
